import { css, jsx } from '@emotion/core';
import { Col, Input } from 'antd';
import React, { useState } from 'react';
import { connect } from 'react-redux';

import Form from '@/src/shared/components/Form';
import { bp, colors } from '@/styles';

const styles = {
  inputContainer: css`
    margin: 1.6rem 0;
    @media ${bp.md} {
      max-width: 36.5rem;
    }

    .ant-input {
      border: 1px solid ${colors.accentGrayMedium};
      background-color: ${colors.white};
    }
  `,
};

const TextInput = ({ form, info, updateProfile, currentInfo, key, onChange }) => {
  const [isEmailValid, setEmailValid] = useState(false);

  const handleConfirmBlur = e => {
    const {
      target: { value },
    } = e;
    setEmailValid(isEmailValid || !!value);
  };

  const validateFirstEmail = (rule, value, callback) => {
    if (value && value !== form.getFieldValue('EmailAddress')) {
      callback('Enter the same email.');
    } else {
      callback();
    }
  };

  const validateConfirmEmail = (rule, value, callback) => {
    if (value && isEmailValid) {
      form.validateFields(['ConfirmEmailAddress'], { force: true });
    }
    callback();
  };

  return (
    <>
      <Col key={key} css={styles.inputContainer} lg={8} xs={24} className="gutter-row">
        <Form.Item label="Email" hasFeedback>
          {form.getFieldDecorator('EmailAddress', {
            initialValue: updateProfile['EmailAddress'],
            rules: [
              {
                required: true,
                message: 'Enter email.',
              },
              {
                validator: validateConfirmEmail,
              },
              {
                required: true,
                message: 'Please confirm your email.',
              },
              {
                type: 'email',
                message: 'Enter valid email.',
              },
            ],
          })(
            <Input
              onChange={e => {
                onChange('EmailAddress', e);
              }}
              size="large"
            />
          )}
        </Form.Item>
      </Col>
      <Col key={key} css={styles.inputContainer} lg={8} xs={24} className="gutter-row">
        <Form.Item label="Confirm Email" hasFeedback>
          {form.getFieldDecorator('ConfirmEmailAddress', {
            initialValue: updateProfile['ConfirmEmailAddress'],
            rules: [
              {
                required: true,
                message: 'Please confirm your email.',
              },
              {
                type: 'email',
                message: 'Enter valid email.',
              },
              {
                validator: validateFirstEmail,
              },
            ],
          })(
            <Input
              onChange={e => {
                onChange('ConfirmEmailAddress', e);
              }}
              size="large"
              onBlur={handleConfirmBlur}
            />
          )}
        </Form.Item>
      </Col>
    </>
  );
};

const mapStateToProps = ({ updateProfile }) => {
  return {
    updateProfile,
  };
};

TextInput.defaultProps = {
  formOverrides: {},
  onChange: () => {},
};
export default connect(
  mapStateToProps,
  {}
)(TextInput);
